import { init, captureException } from '@sentry/browser';
export { captureException };

/* istanbul ignore if */
if (typeof SENTRY_DSN !== 'undefined' && SENTRY_DSN) {
  init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: typeof RELEASE !== 'undefined' ? RELEASE : undefined,
    tracesSampleRate: 0.1, // sample 10% of errors, to reduce load on Sentry
  });
}
